import { LoaderFunction } from "react-router-dom";
import { auth } from "~/lib/firebase";
import { getReadyAuthUser } from "~/utils/auth/waitForAuthReady";
import { getUserInfoWithLambda } from "~/services/server/user-tenant/getUserInfoWithLambda";
import { loadCookiesData } from "~/utils/auth/loadCookiesData";
import { mapFirestoreProfileToDisplay } from "~/utils/mapFirestoreProfileToDisplay";
import type { MainLayoutLoaderData } from "../MainLayout";

/**
 * Unified layout loader. Allows guests; loads owner context and profile when signed in.
 * Available via useRouteLoaderData("main").
 */
export const MainLayoutLoader: LoaderFunction = async () => {
  const user = await getReadyAuthUser();

  if (!user) {
    return {
      user: null,
      ownerID: "",
      ownerType: null,
      role: null,
      profile: null,
      isAuthenticated: false,
    } satisfies MainLayoutLoaderData;
  }

  const cookiesData = await loadCookiesData(user.uid);

  let profile = mapFirestoreProfileToDisplay(cookiesData.profile);
  if (!cookiesData.didFetchUserLoader) {
    const userInfo = await getUserInfoWithLambda({ userID: user.uid });
    profile = mapFirestoreProfileToDisplay(userInfo.profile);
  }

  if (!cookiesData.success) {
    return {
      user,
      ownerID: "",
      ownerType: null,
      role: null,
      profile,
      isAuthenticated: true,
      error: String(cookiesData.error),
    } satisfies MainLayoutLoaderData;
  }

  return {
    user,
    ownerID: cookiesData.data.ownerID,
    ownerType: cookiesData.data.ownerType,
    role: cookiesData.data.role,
    profile,
    isAuthenticated: true,
  } satisfies MainLayoutLoaderData;
};
